import { render } from "./SewaPajakTable.vue?vue&type=template&id=f14dc8b4"
import script from "./SewaPajakTable.vue?vue&type=script&lang=js"
export * from "./SewaPajakTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__